import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import { IPorscheExport } from '../../dashboard/attendees-service/attendees-model';

const EXCEL_TYPE =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable()
export class ExcelService {

    public exportAsExcelFile(json: any[], excelFileName: string): void {
        const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
        const workbook: XLSX.WorkBook = {
            Sheets: { data: worksheet },
            SheetNames: ['data']
        };
        const excelBuffer: any = XLSX.write(workbook, {
            bookType: 'xlsx',
            type: 'array'
        });
        this.saveAsExcelFile(excelBuffer, excelFileName);
    }

    private saveAsExcelFile(buffer: any, name: string): void {
        const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
        const fileName = name ? name + '_' : '';
        FileSaver.saveAs(
            data,
            fileName + 'export_' + new Date().getTime() + EXCEL_EXTENSION
        );
    }

    public formatPorscheExcel(data: IPorscheExport[]) {
        const formattedData = [];

        for (const porscheExport of data) {
            const row: any = { };

            row['SOURCE'] = porscheExport.source;
            row['ID'] = '';
            row['TITLE'] = porscheExport.title;
            row['TITLE_TEXT'] = porscheExport.titleName;
            row['TITLE_ACA1'] = '';
            row['TITLE_ROYL'] = '';
            row['YBUSINESSTITLE'] = '';
            row['YSUFFIX'] = '';
            row['INITIALS'] = '';
            row['NAME_FIRST'] = porscheExport.firstName;
            row['NAME_LAST'] = porscheExport.lastName;
            row['LAST_NAME2'] = '';
            row['NAMEMIDDLE'] = '';
            row['NAME_LST2'] = '';
            row['YCOMPANY1'] = porscheExport.company;
            row['YCOMPANY2'] = '';
            row['LANGU_CORR'] = '';
            row['NAME_CO'] = '';
            row['STREET'] = porscheExport.street;
            row['STR_SUPPL1'] = porscheExport.address;
            row['STR_SUPPL2'] = '';
            row['STR_SUPPL3'] = '';
            row['HOUSE_NUM1'] = porscheExport.streetNumber;
            row['HOUSE_NUM2'] = '';
            row['POST_CODE1'] = porscheExport.postCode;
            row['CITY1'] = porscheExport.city;
            row['REGION'] = '';
            row['BUILDING'] = '';
            row['ROOMNUMBER'] = '';
            row['FLOOR'] = '';
            row['COUNTRY'] = porscheExport.countryCode;
            row['PO_BOX'] = '';
            row['POST_CODE2'] = '';
            row['LOCATION'] = '';
            row['HOME_CITY'] = '';
            row['PO_BOX_LOC'] = '';
            row['SEX'] = '';
            row['MARST'] = '';
            row['BIRTHDATE'] = '';
            row['YYEAR_OF_BIRTH'] = '';
            row['YYEAR_OF_BIRTHTO'] = '';
            row['OCCUPATION'] = '';
            row['TELEPHONE_F'] = '';
            row['EXTENSION_F'] = '';
            row['TELEPHONE_F_REM'] = '';
            row['TELEPHONE_F2'] = '';
            row['EXTENSION_F2'] = '';
            row['TELEPHONE_F2_REM'] = '';
            row['TELEPHONE_M'] = porscheExport.mobileNumber;
            row['TELEPHONE_M_REM'] = '';
            row['TELEPHONE_M2'] = '';
            row['TELEPHONE_M2_REM'] = '';
            row['FAX_F'] = '';
            row['FEXTENSION_F'] = '';
            row['FAX_F_REM'] = '';
            row['SMTP_ADDR1'] = porscheExport.email;
            row['E_MAIL_REM'] = '';
            row['SMTP_ADDR2'] = '';
            row['E_MAIL_REM2'] = '';
            row['DEFLT_COMM'] = '';
            row['YREACHABLE_FROM'] = '';
            row['YREACHABLE_UNTIL'] = '';
            row['YPREF_SAL_DEALER'] = porscheExport.porscheCenter;
            row['YPREF_SRV_DEALER'] = '';
            row['INCOME'] = '';
            row['YCOMMERCIAL'] = '';
            row['MEDIUM'] = '';
            row['MAKE1'] = '';
            row['MODEL1'] = '';
            row['MODEL_YEAR1'] = '';
            row['INSPECTION1'] = '';
            row['MAKE2'] = '';
            row['MODEL2'] = '';
            row['MODEL_YEAR2'] = '';
            row['INSPECTION2'] = '';
            row['MAKE3'] = '';
            row['MODEL3'] = '';
            row['MODEL_YEAR3'] = '';
            row['INSPECTION3'] = '';
            row['CAR_PURCHASE'] = '';
            row['CAR_PUR_MM'] = porscheExport.purchaseInterestMonth;
            row['CAR_PUR_JJJJ'] = porscheExport.purchaseInterestYear;
            row['PRIMARY_INTEREST'] = porscheExport.modelCode;
            row['INTEREST_NV'] = porscheExport.isNewCarInterest;
            row['INTEREST_CPO'] = porscheExport.isUsedCarInterest;
            row['MODEL_INTEREST1'] = porscheExport.modelVariantCode;
            row['MODEL_INTEREST2'] = '';
            row['MODEL_INTEREST3'] = '';
            row['MODEL_INT_OTHER'] = '';
            row['INFO_MATERIAL1'] = '';
            row['INFO_MATERIAL2'] = '';
            row['INFO_MATERIAL3'] = '';
            row['INFO_MATERIAL4'] = '';
            row['INFO_MATERIAL5'] = '';
            row['INFO_MATER_TXT'] = '';
            row['INT_OT1'] = '';
            row['INT_OT2'] = '';
            row['INT_OT3'] = '';
            row['DEALER_CONTACT'] = porscheExport.dealerContact;
            row['TEST_DRIVE'] = '';
            row['CAMPAIGN_ID'] = porscheExport.campaignId;
            row['LEAD_TYPE'] = '';
            row['LEAD_SOURCE'] = '';
            row['PARTNER'] = porscheExport.partner;
            row['IMP'] = '';
            row['MANUAL_SCORE'] = '';
            row['MAN_SCORE_REASON'] = '';
            row['LEAD_DATE'] = porscheExport.eventStartDate;
            row['LEAD_DESC'] = porscheExport.eventName;
            row['LEAD_CVEHI_MAKE'] = '';
            row['LEAD_CVEHI_MOD'] = '';
            row['RESPONSE'] = '';
            row['PURCHINF_AMOUNT'] = '';
            row['ADDRESS_TYPE'] = porscheExport.addressType;
            row['CLUBMEMBER'] = '';
            row['CLUB'] = '';
            row['CLUBMEMBERSINCE'] = '';
            row['HOBBIES'] = '';
            row['YINDUSTRY'] = '';
            row['YINDUSTRYSEC'] = '';
            row['YKIS_DATAPROC'] = porscheExport.agreedDataProtection;
            row['YBLOCK_MAIL'] = porscheExport.isMailBlock;
            row['YBLOCK_PHONE'] = porscheExport.isPhoneBlock;
            row['YBLOCK_EMAIL'] = porscheExport.isEmailBlock;
            row['YBLOCK_FAX'] = porscheExport.isFaxBlock;
            row['YFURTHER_EMAIL'] = '';
            row['COMMENTS'] = '';
            row['CON_PROCESS_TYPE'] = porscheExport.eventParticipation;
            row['CON_REASON_CODE'] = '';
            row['CON_DESCRIPTION'] = porscheExport.eventDescription;
            row['CON_CAMPAIGN_ID'] = porscheExport.extraCampaignId;
            row['CON_STATUS'] = porscheExport.conStatus;
            row['CON_VIN'] = '';
            row['CON_PLAN_DATE'] = porscheExport.eventPlanDate;
            row['CON_PLAN_TIME'] = '';
            row['CON_ACTUAL_DATE'] = porscheExport.eventActualDate;
            row['CON_ACTUAL_TIME'] = '';
            row['CON_INFO'] = '';
            row['VIN1'] = '';
            row['ENERGY_TYPE1'] = '';
            row['BODY_TYPE1'] = '';
            row['TRANSM_TYPE1'] = '';
            row['TAX_CLASS1'] = '';
            row['LICENSE_PLATE1'] = '';
            row['OWNER_REG_DATE1'] = '';
            row['FIRST_REG_DATE1'] = '';
            row['OWNER_END_DATE1'] = '';
            row['ANTICIP_CHANGE1'] = '';
            row['MODEL_VERSION1'] = '';
            row['MILEAGE1'] = '';
            row['PURCHASE_DATE1'] = '';
            row['PURCHASE_TYPE1'] = '';
            row['VEH_CATEGORY1'] = '';
            row['VEH_REPLACEMENT1'] = '';
            row['VIN2'] = '';
            row['ENERGY_TYPE2'] = '';
            row['BODY_TYPE2'] = '';
            row['TRANSM_TYPE2'] = '';
            row['TAX_CLASS2'] = '';
            row['LICENSE_PLATE2'] = '';
            row['OWNER_REG_DATE2'] = '';
            row['FIRST_REG_DATE2'] = '';
            row['OWNER_END_DATE2'] = '';
            row['ANTICIP_CHANGE2'] = '';
            row['MODEL_VERSION2'] = '';
            row['MILEAGE2'] = '';
            row['PURCHASE_DATE2'] = '';
            row['PURCHASE_TYPE2'] = '';
            row['VEH_CATEGORY2'] = '';
            row['VEH_REPLACEMENT2'] = '';
            row['VIN3'] = '';
            row['ENERGY_TYPE3'] = '';
            row['BODY_TYPE3'] = '';
            row['TRANSM_TYPE3'] = '';
            row['TAX_CLASS3'] = '';
            row['LICENSE_PLATE3'] = '';
            row['OWNER_REG_DATE3'] = '';
            row['FIRST_REG_DATE3'] = '';
            row['OWNER_END_DATE3'] = '';
            row['ANTICIP_CHANGE3'] = '';
            row['MODEL_VERSION3'] = '';
            row['MILEAGE3'] = '';
            row['PURCHASE_DATE3'] = '';
            row['PURCHASE_TYPE3'] = '';
            row['VEH_CATEGORY3'] = '';
            row['VEH_REPLACEMENT3'] = '';
            row['YCHRIST_SUB'] = '';
            row['YCHRST_SUB_UNTIL'] = '';
            row['YCHRST_IDTYPE'] = '';
            row['YCHRST_COMPL'] = '';
            row['YCHRST_COMPL_REA'] = '';
            row['YCHRST_COMPL_UNT'] = '';
            row['LEAD_VIN_INT'] = '';
            row['ACTVT_TDID'] = porscheExport.actvt;
            row['TYPE'] = '';
            row['IDNUMBER'] = '';
            row['YRSALESP'] = '';
            row['YRSERVP'] = '';
            row['YYQUESTION1'] = '';
            row['YYQUESTION2'] = '';
            row['YYQUESTION3'] = '';
            row['YPO_BLOCK'] = '';
            row['YPOPA_BLOCK'] = '';
            row['YPODLR_BLOCK'] = '';

            formattedData.push(row);
        }
        return formattedData;
    }
}
